import { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Login, Register, PasswordEdit,
  EmailConfirmation, FrontPage, Profile,
  NewProvider, ProviderDashboard, ProviderProduct, ProviderDiscountForm,
  ProviderDetails, Home, ProtectedRoute, ProviderShop,
  AddressForm, ShoppingCartCheckout, OrderDetails,
  ShopInfo, DeliveryDashboard, DeliveryDetails, Search,
  MyPets, PetDetails, ControlCenter, CampaignList, CampaignForm, RouterLayer, EditProfile, MyOrders, CheckoutSuccess, AddressesManagement } from './components';
import { SnackbarProvider } from "./contexts/SnackbarContext";
import ServiceWorkerUpdatePrompt from './components/ServiceWorkerUpdatePrompt';
import { ThemeProvider } from '@mui/material/styles';
import { ShoppingCartProductsProvider } from './contexts/ShoppingCartProductsContext';
import { SearchProvider } from './contexts/SearchContext';
import { PetsProvider } from './contexts/PetsContext';
import { Box, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
        <ServiceWorkerUpdatePrompt />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SearchProvider>
            <ShoppingCartProductsProvider>
              <PetsProvider>
                <div className="App">
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: 'md',
                      mx: 'auto',
                      minWidth: 0,
                    }}
                  >
                    <Router>
                      <RouterLayer>
                        <Routes>
                          <Route element={<ProtectedRoute />}>
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/new-provider" element={<NewProvider />} />
                            <Route path="/provider-dashboard" element={<ProviderDashboard />} />
                            <Route path="/provider/products/new" element={<ProviderProduct />} />
                            <Route path="/provider/products/:id" element={<ProviderProduct />} />
                            <Route path="/provider/discounts/new" element={<ProviderDiscountForm />} />
                            <Route path="/provider/discounts/:id" element={<ProviderDiscountForm />} />
                            <Route path="/provider/:id/details" element={<ProviderDetails />} />
                            <Route path="/orders/:id" element={<OrderDetails />} />
                            <Route path="/delivery-dashboard" element={<DeliveryDashboard />} />
                            <Route path="/orders/:id/delivery" element={<DeliveryDetails />} />
                            <Route path="/mypets" element={<MyPets />} />
                            <Route path="/mypets/:id/details" element={<PetDetails />} />
                            <Route path="/control-center" element={<ControlCenter />} />
                            <Route path="/control-center/campaigns" element={<CampaignList />} />
                            <Route path="/control-center/campaigns/new" element={<CampaignForm />} />
                            <Route path="/control-center/campaigns/:id" element={<CampaignForm />} />
                            <Route path="/shopping-cart" element={<ShoppingCartCheckout />} />
                            <Route path="/address" element={<AddressForm />} />
                            <Route path="/addresses" element={<AddressesManagement />} />
                            <Route path="/addresses/new" element={<AddressForm />} />
                            <Route path="/addresses/:id/edit" element={<AddressForm />} />
                            <Route path="/profile/edit" element={<EditProfile />} />
                            <Route path="/orders" element={<MyOrders />} />
                            <Route path="/checkout-success" element={<CheckoutSuccess />} />
                          </Route>

                          <Route path="/" element={<Navigate to="/home" />} />
                          <Route path="/home" element={<Home />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/register" element={<Register />} />
                          <Route path="/users/password/edit" element={<PasswordEdit />} />
                          <Route path="/confirmation" element={<EmailConfirmation />} />
                          <Route path="/search" element={<Search />} />
                          <Route path="/inicio" element={<FrontPage />} />
                          <Route path="/provider/:id" element={<ProviderShop />} />
                          <Route path="/shop_info" element={<ShopInfo />} />
                          <Route path="/inicio" element={<FrontPage />} />
                        </Routes>
                      </RouterLayer>
                    </Router>
                  </Box>
                </div>
              </PetsProvider>
            </ShoppingCartProductsProvider>
          </SearchProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
